import { useEffect, useState } from 'react';
import { isEmptyStr } from 'utils/helpers';
import trimStart from 'lodash/trimStart';
import useConditionalDebounce from './useConditionalDebounce';

const useConditionallyDebouncedInput = ({
    value,
    debounceTimeout,
    onChange,
    shouldDebounce,
}) => {
    const [inputValue, setInputValue] = useState(value);
    const [isTyping, setIsTyping] = useState(false);
    const debouncedInputValue = useConditionalDebounce(
        inputValue,
        debounceTimeout,
        shouldDebounce,
    );

    useEffect(() => {
        onChange(debouncedInputValue);
        setIsTyping(false);
    }, [debouncedInputValue]);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const onInputChange = (e) => {
        const trimmedInputValue = trimStart(e.target.value);
        setInputValue(trimmedInputValue);
        if (!isEmptyStr(trimmedInputValue)) {
            setIsTyping(true);
        }
    };

    return {
        inputValue,
        setInputValue,
        isTyping,
        onInputChange,
    };
};

export default useConditionallyDebouncedInput;
